export default __webpack_public_path__ + "static/media/Aero2.771830f6.png";